import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import OrganizationComponent from '../components/organization.component';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import storePersist from '../../../../../../redux/storePersist';
import PageLoader from '../../../../../../components/PageLoader';
import { organizations } from '../../../../../../redux/organizations/action';
import { selectOrganizationsQueryItems } from '../../../../../../redux/organizations/selector';

const ManagementOrganization = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const organizationsQuery = useSelector(selectOrganizationsQueryItems)
  const librariesItems = storePersist?.get("library")?.current;
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const [
    selectedAddress,
    setSelectedAddress
  ] = useState<any>({

    PrimaryAddress: {},
    BillingAddress: {},
    ShippingAddress: {}

  })  
  const [
    organization,
    setOrganization
  ] = useState<any>([])

  const fetchOrganizationQueryById= ()=>{
    dispatch(organizations.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organizations/query`,entity:'organizations',jsonData:{
          
    Records: [
      {
        Id: 0
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setOrganization({ ...organization, [field]: event })
  }
  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setOrganization({ ...organization, [fields[0]]: value });
    setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }
  useEffect(
    () => {
    
        fetchOrganizationQueryById()
        setIsLoading(false)

    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setOrganization(organizationsQuery?.result?.items)
        setSelectedAddress({ 
            PrimaryAddress: organizationsQuery?.result?.items?.PrimaryAddress,
            BillingAddress: organizationsQuery?.result?.items?.BillingAddress,
            ShippingAddress: organizationsQuery?.result?.items?.ShippingAddress})
      }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const organizationData= {
   
        OrganizationInfo: {
          Id: organization?.OrganizationInfo?.Id,
          Name: organization?.OrganizationInfo?.Name,
          Email: organization?.OrganizationInfo?.Email,
          PhoneNumber: organization?.OrganizationInfo?.PhoneNumber,
          CountryCode: organization?.OrganizationInfo?.CountryCode,
          IsCSGAccessEnabledForPortal: organization?.OrganizationInfo?.IsCSGAccessEnabledForPortal,
          IsCSGAccessEnabledForService: organization?.OrganizationInfo?.IsCSGAccessEnabledForService
        },
        PrimaryAddress:selectedAddress?.PrimaryAddress,
        IsUsePrimaryAddressAsBillingAddress: organization?.IsUsePrimaryAddressAsBillingAddress || false,
        BillingAddress: selectedAddress?.BillingAddress,
        IsUsePrimaryAddressAsShippingAddress: organization?.IsUsePrimaryAddressAsShippingAddress || false,
        ShippingAddress: selectedAddress?.ShippingAddress,
        DBNIE: {
          Id: organization?.DBNIE?.Id || 0,
          Name: organization?.DBNIE?.Name,
          URL: organization?.DBNIE?.URL,
          Secret: organization?.DBNIE?.Secret,
          IsActive: organization?.DBNIE?.IsActive
        },
        DBN: organization?.DBN
      }
     dispatch(organizations.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organizations`,entity:'organizations',jsonData:{
          
    Records: [
       organizationData
    ]
 
}}))
.then(()=>{
    back()
  })
  }

const back=()=>{
  navigate('/management/organization/organization-management/organizations')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <OrganizationComponent 
          handleFormSubmit={handleFormSubmit}
          back={back}
          currencyCodeType={librariesItems?.CurrencyCodeType}
          handleInnerbasicFormChange={handleInnerbasicFormChange}
          onInnerFormChange ={handleInnerFormChange}
          selectedAddress={selectedAddress}
          organization={organization}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementOrganization;